export let addMultiEventsListener = (eventNames, listener) => {
  var events = eventNames.split(' ');

  for (var i=0, iLen=events.length; i<iLen; i++) {
    document.addEventListener(events[i], listener, false);
  }
}
